import React, { useEffect, useState } from 'react';
import { api } from '../api/client';

const TYPES: Record<string, string> = {
  hoa_fixed: 'СӨХ (тогтмол)', hoa_per_sqm: 'СӨХ (м²)', electricity: 'Цахилгаан',
  water_hot: 'Халуун ус', water_cold: 'Хүйтэн ус', heating: 'Дулаан',
};
/** Айлын төрөл — тариф тухайн төрлийн айлд л үйлчилнэ; хоосон бол бүх айлд. Төрөлтэй тариф нь «бүх төрөл»-өөс давуу. */
const UNIT_TYPES: Record<string, string> = { '': 'Бүх төрөл', apartment: 'Орон сууц', townhouse: 'Таунхаус', house: 'Single хаус', garage: 'Зогсоол', commercial: 'Арилжааны' };
const UNITS: Record<string, string> = {
  hoa_fixed: '₮/сар', hoa_per_sqm: '₮/м²', electricity: '₮/кВт',
  water_hot: '₮/м³', water_cold: '₮/м³', heating: '₮/м²',
};

interface TariffForm {
  tariff_type: string; unit_type: string; name: string; rate: string; unit_label: string; effective_from: string;
}
const emptyForm: TariffForm = {
  tariff_type: 'hoa_per_sqm', unit_type: '', name: '', rate: '', unit_label: '', effective_from: new Date().toISOString().slice(0, 10),
};

export default function TariffsPage() {
  const [items, setItems] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [editId, setEditId] = useState<string | null>(null);
  const [form, setForm] = useState<TariffForm>(emptyForm);

  const load = () => {
    setLoading(true);
    api.get('/admin/tariffs')
      .then(data => setItems(data?.items || []))
      .catch(() => {})
      .finally(() => setLoading(false));
  };

  useEffect(() => { load(); }, []);

  const handleSubmit = async () => {
    const payload: any = { ...form, rate: parseFloat(form.rate) };
    if (!payload.name) payload.name = TYPES[form.tariff_type] || form.tariff_type;
    if (!payload.unit_label) payload.unit_label = UNITS[form.tariff_type] || '';
    try {
      if (editId) {
        await api.put(`/admin/tariffs/${editId}`, { rate: payload.rate, name: payload.name, unit_label: payload.unit_label, unit_type: payload.unit_type });
      } else {
        await api.post('/admin/tariffs', payload);
      }
      setShowForm(false); setEditId(null); setForm(emptyForm); load();
    } catch { /* ignore */ }
  };

  const toggleActive = async (t: any) => {
    try { await api.put(`/admin/tariffs/${t.id}`, { is_active: !t.is_active }); load(); } catch {}
  };

  const handleDelete = async (id: string) => {
    if (!window.confirm('Устгах уу?')) return;
    try { await api.delete(`/admin/tariffs/${id}`); load(); } catch {}
  };

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
        <h2 style={{ fontFamily: "'Inter'", fontWeight: 700, fontSize: 24, color: '#1c2b22', margin: 0 }}>
          Тариф удирдлага
        </h2>
        <button onClick={() => { setEditId(null); setForm(emptyForm); setShowForm(true); }} style={btnPrimary}>
          + Шинэ тариф
        </button>
      </div>

      {loading ? <p style={{ color: '#5f6f66' }}>Уншиж байна...</p> : (
        <div style={{ background: '#fff', borderRadius: 12, overflow: 'hidden', boxShadow: '0 1px 3px rgba(0,0,0,0.06)' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ background: '#f8f7f4' }}>
                <th style={th}>Төрөл</th>
                <th style={th}>Айлын төрөл</th>
                <th style={th}>Нэр</th>
                <th style={th}>Тариф</th>
                <th style={th}>Нэгж</th>
                <th style={th}>Эхлэх огноо</th>
                <th style={th}>Төлөв</th>
                <th style={th}>Үйлдэл</th>
              </tr>
            </thead>
            <tbody>
              {items.map(t => (
                <tr key={t.id} style={{ borderBottom: '1px solid #f0f0f0', opacity: t.is_active ? 1 : 0.5 }}>
                  <td style={td}>{TYPES[t.tariff_type] || t.tariff_type}</td>
                  <td style={td}><span style={{ padding: '2px 8px', borderRadius: 10, fontSize: 12, background: t.unit_type ? '#eef2ff' : '#f3f4f6', color: t.unit_type ? '#3730a3' : '#6b7280', fontWeight: 600 }}>{UNIT_TYPES[t.unit_type || ''] || t.unit_type}</span></td>
                  <td style={td}>{t.name}</td>
                  <td style={{ ...td, fontWeight: 600, color: '#236844' }}>{t.rate?.toLocaleString()}</td>
                  <td style={td}>{t.unit_label}</td>
                  <td style={td}>{t.effective_from}</td>
                  <td style={td}>
                    <span style={{
                      padding: '2px 8px', borderRadius: 10, fontSize: 11, fontWeight: 600,
                      background: t.is_active ? '#f0f9f4' : '#fef2f2',
                      color: t.is_active ? '#236844' : '#ef4444',
                    }}>{t.is_active ? 'Идэвхтэй' : 'Идэвхгүй'}</span>
                  </td>
                  <td style={td}>
                    <div style={{ display: 'flex', gap: 6 }}>
                      <button onClick={() => {
                        setEditId(t.id);
                        setForm({ tariff_type: t.tariff_type, unit_type: t.unit_type || '', name: t.name, rate: String(t.rate), unit_label: t.unit_label || '', effective_from: t.effective_from || '' });
                        setShowForm(true);
                      }} style={smallBtn}>Засах</button>
                      <button onClick={() => toggleActive(t)} style={smallBtn}>{t.is_active ? 'Зогсоох' : 'Идэвхжүүлэх'}</button>
                      <button onClick={() => handleDelete(t.id)} style={{ ...smallBtn, color: '#ef4444' }}>Устгах</button>
                    </div>
                  </td>
                </tr>
              ))}
              {items.length === 0 && (
                <tr><td colSpan={8} style={{ ...td, textAlign: 'center', color: '#94a3b8', padding: 40 }}>Тариф олдсонгүй</td></tr>
              )}
            </tbody>
          </table>
        </div>
      )}

      {showForm && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}
          onClick={() => setShowForm(false)}>
          <div style={{ background: '#fff', borderRadius: 16, padding: 32, width: 440 }} onClick={e => e.stopPropagation()}>
            <h3 style={{ fontFamily: "'Inter'", fontWeight: 700, fontSize: 20, color: '#1c2b22', marginTop: 0 }}>
              {editId ? 'Тариф засах' : 'Шинэ тариф'}
            </h3>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
              {!editId && (
                <div>
                  <label style={labelStyle}>Төрөл</label>
                  <select value={form.tariff_type} onChange={e => setForm({ ...form, tariff_type: e.target.value, unit_label: UNITS[e.target.value] || '' })} style={inputStyle}>
                    {Object.entries(TYPES).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
                  </select>
                </div>
              )}
              <div>
                <label style={labelStyle}>Айлын төрөл</label>
                <select value={form.unit_type} onChange={e => setForm({ ...form, unit_type: e.target.value })} style={inputStyle}>
                  {Object.entries(UNIT_TYPES).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
                </select>
                <div style={{ fontSize: 12, color: '#6b7280', marginTop: 4 }}>Жишээ: орон сууц 1 500 ₮/м², таунхаус 120 000 ₮/сар тогтмол, Single хаус 90 000 ₮/сар. Төрөлтэй тариф «Бүх төрөл»-өөс давуу.</div>
              </div>
              <div>
                <label style={labelStyle}>Тариф (₮)</label>
                <input type="number" value={form.rate} onChange={e => setForm({ ...form, rate: e.target.value })} style={inputStyle} placeholder="1500" />
              </div>
              <div>
                <label style={labelStyle}>Нэгж</label>
                <input value={form.unit_label} onChange={e => setForm({ ...form, unit_label: e.target.value })} style={inputStyle} placeholder="₮/м²" />
              </div>
              {!editId && (
                <div>
                  <label style={labelStyle}>Эхлэх огноо</label>
                  <input type="date" value={form.effective_from} onChange={e => setForm({ ...form, effective_from: e.target.value })} style={inputStyle} />
                </div>
              )}
              <div style={{ display: 'flex', gap: 12, justifyContent: 'flex-end' }}>
                <button onClick={() => setShowForm(false)} style={{ padding: '10px 20px', border: '1px solid #d1d5db', borderRadius: 8, background: '#fff', cursor: 'pointer' }}>Цуцлах</button>
                <button onClick={handleSubmit} disabled={!form.rate} style={{ ...btnPrimary, opacity: form.rate ? 1 : 0.5 }}>
                  {editId ? 'Хадгалах' : 'Нэмэх'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

const th: React.CSSProperties = { textAlign: 'left', padding: '12px 16px', fontSize: 12, color: '#5f6f66', fontWeight: 600 };
const td: React.CSSProperties = { padding: '12px 16px', fontSize: 14 };
const btnPrimary: React.CSSProperties = {
  background: 'linear-gradient(180deg, #2f7d52, #236844)', color: '#fff', border: 'none',
  padding: '10px 20px', borderRadius: 10, cursor: 'pointer', fontWeight: 600, fontSize: 14, fontFamily: "'Inter'",
};
const smallBtn: React.CSSProperties = {
  background: '#f0f9f4', border: 'none', borderRadius: 6, padding: '4px 10px', cursor: 'pointer', color: '#236844', fontSize: 12,
};
const labelStyle: React.CSSProperties = { display: 'block', marginBottom: 4, fontSize: 13, color: '#374151', fontWeight: 500 };
const inputStyle: React.CSSProperties = {
  width: '100%', padding: '10px 12px', border: '1px solid #d1d5db', borderRadius: 8, fontSize: 14, boxSizing: 'border-box',
};
